/** @module config/transitionWords */

export default [
	[ "だから" ],
	[ "その", "ため" ],
	[ "この", "ため" ],
	[ "それ", "で" ],
	[ "そこ", "で" ],
	[ "よって" ],
	[ "する", "と" ],
	[ "だと", "する", "と" ],
	[ "ゆえ", "に" ],
	[ "それゆえ", "に" ],
	[ "し", "た", "がっ", "て" ],
	[ "それゆえ" ],
	[ "それ", "なら" ],
	[ "それ", "で", "は" ],
	[ "ならば" ],
	[ "だ", "と", "し", "たら" ],
	[ "そう", "する", "と" ],
	[ "そう", "し", "たら" ],
	[ "さも", "ない", "と" ],
	[ "そうし", "ない", "と" ],
	[ "そう", "で", "ない", "なら" ],
	[ "だと", "すれ", "ば" ],
	[ "そう", "なる", "と" ],
	[ "と", "なる", "と" ],
	[ "と", "なれ", "ば" ],
	[ "そうして", "みる", "と" ],
	[ "そう", "なれ", "ば" ],
	[ "そうして" ],
	[ "そのけっか" ],
	[ "その", "結果" ],
	[ "しかし" ],
	[ "けど" ],
	[ "ただ" ],
	[ "だ", "が" ],
	[ "しかし", "ながら" ],
	[ "けれど" ],
	[ "けれども" ],
	[ "だけど" ],
	[ "だけども" ],
	[ "そう", "で", "は", "ある", "が" ],
	[ "それ", "でも" ],
	[ "でも" ],
	[ "で", "は", "ある", "が" ],
	[ "に", "も", "かかわらず" ],
	[ "それ", "に", "も", "かかわらず" ],
	[ "ところ", "が" ],
	[ "しかる", "に" ],
	[ "と", "はいう", "もの", "の" ],
	[ "と", "は", "言う", "もの", "の" ],
	[ "な", "の", "に" ],
	[ "それ", "な", "の", "に" ],
	[ "と", "は", "いえ" ],
	[ "そう", "はいう", "もの", "の" ],
	[ "そう", "は", "言う", "もの", "の" ],
	[ "そのくせ" ],
	[ "さり", "と", "て" ],
	[ "さ", "れど" ],
	[ "これ", "に", "はんし", "て" ],
	[ "これ", "に", "反し", "て" ],
	[ "それ", "に", "し", "て", "は" ],
	[ "そのわり", "に", "は" ],
	[ "そのわり", "に" ],
	[ "それ", "なら" ],
	[ "ならび", "に" ],
	[ "おなじく" ],
	[ "同じく" ],
	[ "また" ],
	[ "どう", "よう", "に" ],
	[ "同様", "に" ],
	[ "さ", "れど", "も" ],
	[ "さらに" ],
	[ "おなじ", "よう", "に" ],
	[ "同じ", "よう", "に" ],
	[ "のみ", "なら", "ず" ],
	[ "しかも" ],
	[ "おまけ", "に" ],
	[ "そのうえ" ],
	[ "その", "上" ],
	[ "そして" ],
	[ "それ", "から" ],
	[ "それどころか" ],
	[ "どころか" ],
	[ "それ", "に" ],
	[ "それ", "に", "し", "て", "も" ],
	[ "くわえ", "て" ],
	[ "加え", "て" ],
	[ "それ", "にくわえ", "て" ],
	[ "それ", "に", "加え", "て" ],
	[ "ひいて", "は" ],
	[ "なお" ],
	[ "それ", "ばかり", "で", "なく" ],
	[ "それ", "ばかりか" ],
	[ "とも", "あれ" ],
	[ "その", "うえ", "に" ],
	[ "その", "上", "に" ],
	[ "その", "うえ", "で" ],
	[ "その", "上", "で" ],
	[ "あまつさえ" ],
	[ "いっぽう" ],
	[ "一方" ],
	[ "たほう" ],
	[ "他方" ],
	[ "ぎゃく", "に" ],
	[ "逆", "に" ],
	[ "それ", "に", "たいし", "て" ],
	[ "それ", "に対して" ],
	[ "たいし", "て" ],
	[ "対して" ],
	[ "はん", "たい", "に" ],
	[ "反対", "に" ],
	[ "はんめん" ],
	[ "反面" ],
	[ "その", "は", "んめん" ],
	[ "その", "反面" ],
	[ "また", "は" ],
	[ "もしく", "は" ],
	[ "あるい", "は" ],
	[ "それとも" ],
	[ "ほか", "に", "は" ],
	[ "他", "に", "は" ],
	[ "ほか", "に", "も" ],
	[ "他", "に", "も" ],
	[ "だいいち", "に" ],
	[ "第一", "に" ],
	[ "だい", "に", "に" ],
	[ "第二", "に" ],
	[ "だい", "さん", "に" ],
	[ "第三", "に" ],
	[ "だい", "よん", "に" ],
	[ "第四", "に" ],
	[ "ひとつめ", "は" ],
	[ "一つめ", "は" ],
	[ "一つ", "目", "は" ],
	[ "１つめ", "は" ],
	[ "1つ", "目", "は" ],
	[ "ふたつめ", "は" ],
	[ "二つめ", "は" ],
	[ "二つ", "目", "は" ],
	[ "２つめ", "は" ],
	[ "2つ", "目", "は" ],
	[ "みっつめ", "は" ],
	[ "三つめ", "は" ],
	[ "三つ", "目", "は" ],
	[ "３つめ", "は" ],
	[ "3つ", "目", "は" ],
	[ "よっつめ", "は" ],
	[ "四つめ", "は" ],
	[ "四つ", "目", "は" ],
	[ "４つめ", "は" ],
	[ "4つ", "目", "は" ],
	[ "いって", "んめ", "は" ],
	[ "一点目", "は" ],
	[ "1", "点目", "は" ],
	[ "に", "てんめ", "は" ],
	[ "二点目", "は" ],
	[ "2", "点目", "は" ],
	[ "さん", "て", "んめ", "は" ],
	[ "三点目", "は" ],
	[ "3", "点目", "は" ],
	[ "よん", "て", "んめ", "は" ],
	[ "四点目", "は" ],
	[ "4", "点目", "は" ],
	[ "ひとつ", "は" ],
	[ "一つ", "は" ],
	[ "１つ", "は" ],
	[ "もう", "ひ", "とつ", "は" ],
	[ "もう", "一つ", "は" ],
	[ "もう", "１", "つ", "は" ],
	[ "いってん", "は" ],
	[ "一点", "は" ],
	[ "1点", "は" ],
	[ "もういってん", "は" ],
	[ "もう", "一点", "は" ],
	[ "もう", "1", "点", "は" ],
	[ "はじめ", "に" ],
	[ "さいしょ", "に" ],
	[ "最初", "に" ],
	[ "つづい", "て" ],
	[ "続い", "て" ],
	[ "つい", "で" ],
	[ "次い", "で" ],
	[ "さいごに" ],
	[ "最後", "に" ],
	[ "おわり", "に" ],
	[ "終わり", "に" ],
	[ "終り", "に" ],
	[ "その", "ご" ],
	[ "その", "後" ],
	[ "まず" ],
	[ "つぎ", "に" ],
	[ "次", "に" ],
	[ "さらに" ],
	[ "その", "あと" ],
	[ "その", "あと", "に" ],
	[ "その後", "に" ],
	[ "なぜ", "なら" ],
	[ "なぜ", "なら", "ば" ],
	[ "なぜか", "という", "と" ],
	[ "という", "の", "は" ],
	[ "という", "の", "も" ],
	[ "だっ", "て" ],
	[ "なに", "しろ" ],
	[ "なにせ" ],
	[ "どう", "して", "か", "という", "と" ],
	[ "なん", "で", "か", "という", "と" ],
	[ "ち", "なみ", "に" ],
	[ "ただ" ],
	[ "もっとも" ],
	[ "その", "かわり" ],
	[ "ただし" ],
	[ "そも", "そも" ],
	[ "じつ", "は" ],
	[ "実", "は" ],
	[ "じつ", "の", "ところ" ],
	[ "実", "の", "ところ" ],
	[ "じつ", "は", "という", "と" ],
	[ "実", "は", "という", "と" ],
	[ "実", "は", "と", "言う", "と" ],
	[ "つまり" ],
	[ "いいかえる", "と" ],
	[ "言い", "かえる", "と" ],
	[ "言い換える", "と" ],
	[ "す", "なわち" ],
	[ "よう", "は" ],
	[ "要", "は" ],
	[ "とど", "の", "つまり" ],
	[ "よう", "する", "に" ],
	[ "要", "する", "に" ],
	[ "むしろ" ],
	[ "かんげん", "する", "と" ],
	[ "換言", "する", "と" ],
	[ "かえっ", "て" ],
	[ "かわり", "に" ],
	[ "その", "かわり" ],
	[ "いわば" ],
	[ "いって", "みれ", "ば" ],
	[ "言っ", "て", "みれ", "ば" ],
	[ "という", "より" ],
	[ "と言う", "より" ],
	[ "という", "より", "は" ],
	[ "と言う", "より", "は" ],
	[ "という", "より", "も" ],
	[ "と言う", "より", "も" ],
	[ "という", "か" ],
	[ "ぐたい", "て", "き", "に", "は" ],
	[ "具体", "的", "に", "は" ],
	[ "た", "とえば" ],
	[ "例え", "ば" ],
	[ "とりわけ" ],
	[ "なか", "で", "も" ],
	[ "こと", "に" ],
	[ "殊", "に" ],
	[ "とく", "に" ],
	[ "特に" ],
	[ "それ", "に", "は" ],
	[ "その", "ため", "に", "は" ],
	[ "そう", "する", "ば", "あい" ],
	[ "そう", "する", "場合" ],
	[ "その", "ば", "あい" ],
	[ "その", "場合" ],
	[ "そうすれ", "ば" ],
	[ "それ", "によって" ],
	[ "そう", "する", "こと", "で" ],
	[ "さ", "れ", "ば" ],
	[ "さすれ", "ば" ],
	[ "さて" ],
	[ "それ", "につけて", "も" ],
	[ "ところ", "で" ],
	[ "とき", "に" ],
	[ "時", "に" ],
	[ "それ", "は", "さ", "て", "おき" ],
	[ "で", "は" ],
	[ "それ", "で", "は" ],
	[ "じゃ", "あ" ],
	[ "とも", "あれ" ],
	[ "それ", "は", "そう", "と" ],
	[ "そういえ", "ば" ],
	[ "それ", "に", "し", "たっ", "て" ],
	[ "しょせん" ],
	[ "所詮" ],
	[ "ど", "の", "みち" ],
	[ "どの", "道" ],
	[ "どっちみち" ],
	[ "どっち道" ],
	[ "この", "よう", "に" ],
	[ "こうして" ],
	[ "いずれ", "に", "せ", "よ" ],
	[ "いずれ", "に", "し", "て", "も" ],
	[ "どちら", "に", "せ", "よ" ],
	[ "どっち", "に", "し", "て", "も" ],
	[ "どっち", "に", "せ", "よ" ],
	[ "どちら", "に", "し", "て", "も" ],
	[ "とも", "あれ" ],
	[ "いじょう", "の", "よう", "に" ],
	[ "以上", "の", "よう", "に" ],
	[ "たしか", "に" ],
	[ "確か", "に" ],
	[ "いっぽう", "で" ],
	[ "一方", "で" ],
	[ "いっぽう", "で", "は" ],
	[ "一方", "で", "は" ],
	[ "たほう", "で" ],
	[ "他方", "で" ],
	[ "たほう", "で", "は" ],
	[ "他方", "で", "は" ],
	[ "かり", "に" ],
	[ "仮", "に" ],
	[ "た", "とえ" ],
	[ "よしんば" ],
	[ "と", "する", "と" ],
	[ "とすれ", "ば" ],
	[ "し", "から", "ば" ],
	[ "に", "も", "かかわらず" ],
	[ "に", "も", "拘わらず" ],
	[ "といえども" ],
	[ "と", "言え", "ど", "も" ],
	[ "といって", "も" ],
	[ "と言っ", "て", "も" ],
	[ "と", "はいう", "もの", "の" ],
	[ "と", "は", "言う", "もの", "の" ],
	[ "こと", "に", "は" ],
	[ "まも", "なく" ],
	[ "やが", "て" ],
	[ "と", "たん", "に" ],
	[ "つづい", "て" ],
	[ "続い", "て" ],
	[ "ひきつづき" ],
	[ "引き続き" ],
	[ "かと", "おも", "う", "と" ],
	[ "かと", "思う", "と" ],
	[ "かと", "おもえば" ],
	[ "かと", "思え", "ば" ],
	[ "かと", "おもうまも", "なく" ],
	[ "かと", "思う間も", "なく" ],
	[ "かと", "思う", "まも", "なく" ],
	[ "と", "たん" ],
	[ "そのしゅんかん" ],
	[ "その", "瞬間" ],
	[ "どうじ", "に" ],
	[ "同", "時に" ],
	[ "まし", "て" ],
	[ "まし", "て", "や" ],
	[ "これ", "に", "たいし", "て" ],
	[ "これ", "に対して" ],
	[ "もちろん" ],
	[ "も", "とより" ],
	[ "それ", "だ", "から" ],
	[ "これ", "だ", "から" ],
	[ "とうぜん" ],
	[ "当然" ],
];
